import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useSimColumnsTranslations = () => {
  const { t } = useTranslation();

  const idLabelMapForFlatTable: Record<string, string> = useMemo(
    () => ({
      iccid: t('common.iccid'),
      imsi: t('common.imsi'),
      msisdn: t('common.msisdn'),
      currentIpAddress: t('products.sim.lastKnownIP'),
      managementIpAddress: t('common.managementIp'),
      mnoRatePlan: t('common.plan'),
      organisation: t('common.enterprise'),
      dcpEnterprise: t('common.dcpEnterprise'),
      mnoStatus: t('common.mnoStatus'),
      customerCommsPlan: t('simInventory.customerCommsPlan'),
      commsPlan: t('simInventory.commsPlan'),
      mobileNetworkOperator: t('simInventory.mobileNetworkOperator'),
      accountName: t('common.accountName'),
      accountRef: t('common.accountNumber'),
      liveDataUsage: t('products.sim.dataMB'),
      inboundLiveDataUsage: t('products.sim.dataMT'),
      outboundLiveDataUsage: t('products.sim.dataMO'),
      inMinuteUsage: t('products.sim.voiceMT'),
      outMinuteUsage: t('products.sim.voiceMO'),
      inTextUsage: t('products.sim.smsMT'),
      outTextUsage: t('products.sim.smsMO'),
      sessionStartTime: t('simInventory.sessionStartTime'),
      sessionEndTime: t('simInventory.sessionEndTime'),
      sessionStatus: t('simInventory.sessionStatus'),
      sessionStatusLastUpdated: t('simInventory.sessionStatusLastUpdated_flat'),
      connectionId: t('simInventory.connectionId'),
      orderNumber: t('simInventory.orderNumber'),
      tags: t('common.tag'),
      simType: t('simInventory.simType'),
      activeConfiguration: t('simInventory.activeConfiguration'),
      productCode: t('simInventory.productCode'),
      subscriptionStatus: t('simInventory.subscriptionStatus'),
      productType: t('simInventory.productType'),
      installerName: t('simInventory.organisationName'),
      installerRef: t('simInventory.organisationNumber'),
      customerReference: t('products.sim.orderReference'),
      mnoStatusEntryTime: t('simInventory.mnoStatusEntryTime_flat'),
    }),
    [],
  );
  const idLabelMapForCombinedTable: Record<string, string> = useMemo(
    () => ({
      ...idLabelMapForFlatTable,
      sessionStatusLastUpdated: t('simInventory.sessionStatusLastUpdated_combined'),
      mnoStatusEntryTime: t('simInventory.mnoStatusEntryTime_combined'),
    }),
    [],
  );

  return { idLabelMapForFlatTable, idLabelMapForCombinedTable };
};
